// pages/Datasets.js
import React, { useState } from 'react';
import './Datasets.css';
import { Link } from 'react-router-dom';
import rawDatasets from '../data/datasets.json';

const datasets = rawDatasets.map((item, index) => ({
  ...item,
  id: index
}));

const Datasets = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [expandedCard, setExpandedCard] = useState(null);

  const categories = [
    { value: 'all', label: 'All Datasets' },
    { value: 'text', label: 'Text' },
    { value: 'code', label: 'Code' },
    { value: 'conversational', label: 'Conversational' },
    // { value: 'vision', label: 'Vision' },
    // { value: 'scientific', label: 'Scientific' },
    // { value: 'finance', label: 'Finance' },
    // { value: 'multilingual', label: 'Multilingual' }
  ];

  const filteredDatasets = datasets.filter(dataset => {
    const matchesSearch = dataset.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         dataset.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || dataset.categories.includes(selectedCategory);
    const matchCustom = dataset.id === 0;
    return (matchesSearch && matchesCategory) || matchCustom;
  });

  const toggleExpand = (id) => {
    setExpandedCard(expandedCard === id ? null : id);
  };

  return (
    <div className="datasets-page">
      <div className="datasets-hero">
        <div className="datasets-hero-content">
          <h1 className="datasets-hero-title">
            {/* Enterprise-Grade <span className="gradient-text">Datasets</span> */}
            Datasets
          </h1>
          <p className="datasets-hero-subtitle">
          Choose between free open-source datasets or enterprise datasets with enhanced features, larger scale, and commercial licensing.
          </p>
        </div>
      </div>

      <div className="datasets-container">
        <div className="datasets-controls">
          <div className="search-wrapper">
            <svg className="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M19 19L14.65 14.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <input
              type="text"
              placeholder="Search datasets..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>

          <div className="filter-chips">
            {categories.map(category => (
              <button
                key={category.value}
                className={`filter-chip ${selectedCategory === category.value ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category.value)}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>

        <div className="datasets-grid">
          {/* TODO: Add a custom card here for the custom dataset - don't need all that other workaround and can add custom styles as well easier */}
          {filteredDatasets.map(dataset => (
            <div key={dataset.id} className={`dataset-card ${expandedCard === dataset.id ? 'expanded' : ''} ${dataset.id === 0 ? 'custom' : ''}`}
              onClick={() => {if(expandedCard !== dataset.id) {toggleExpand(dataset.id)}}}
            >
              <div className="dataset-header">
                <div className="dataset-title-row">
                  {/* <span className="dataset-icon">{dataset.icon}</span> */}
                  {dataset.icon &&
                  <img src={dataset.icon} alt='dataset icon' className='dataset-icon'/>}
                  <h3 className="dataset-title">{dataset.title}</h3>
                </div>
                <button
                  className="expand-button"
                  onClick={e => {
                    e.stopPropagation();
                    toggleExpand(dataset.id);
                  }}
                  aria-label={expandedCard === dataset.id ? 'Collapse' : 'Expand'}
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d={expandedCard === dataset.id ? "M5 12L10 7L15 12" : "M5 8L10 13L15 8"}
                          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>

              <p className="dataset-description">{dataset.description}</p>
              {dataset.stats &&
              <div className="dataset-stats">
                {Object.entries(dataset.stats).map(([key, value]) => (
                  <div key={key} className="stat-item">
                    <span className="stat-label">{key}</span>
                    <span className="stat-value">{value}</span>
                  </div>
                ))}
              </div>
              }

              <div className="dataset-categories">
                {dataset.categories.map(cat => (
                  <span key={cat} className="category-tag">{cat}</span>
                ))}
              </div>

              {expandedCard === dataset.id && (
                <div className="dataset-expanded">
                  <div className="version-comparison">
                  {dataset.openSource &&
                    <div className="version-column">
                      <h4 className="version-title">Open Source</h4>
                      <div className="version-size">{dataset.openSource.size}<span className="version-size-desc">{dataset.openSource.sizeDesc}</span></div>
                      <ul className="version-features">
                        {dataset.openSource.features.map((feature, idx) => (
                          <li key={idx}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M13 4L6 11L3 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            {feature}
                          </li>
                        ))}
                      </ul>
                      <a className="download-button secondary" href={`https://huggingface.co/datasets/primordic/${dataset.openSource.hfname}`}>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M13 13L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                        Explore
                      </a>
                    </div>
                    }
                    {dataset.enterprise &&
                    <div className="version-column enterprise">
                      <div className="enterprise-badge">Premium</div>
                      <h4 className="version-title">Enterprise</h4>
                      {dataset.enterprise?.size &&
                      <div className="version-size">{dataset.enterprise?.size}<span className="version-size-desc">{dataset.enterprise?.sizeDesc}</span></div>}
                      <ul className="version-features">
                        {(dataset.enterprise?.features || []).map((feature, idx) => (
                          <li key={idx}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M13 4L6 11L3 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            {feature}
                          </li>
                        ))}
                      </ul>

                      <Link to={dataset.id === 0? `/contact?interest=custom-datasets`: `/contact?interest=enterprise-datasets&dataset=${dataset.title}`} className='inquire-link'>
                        <button className="download-button primary">
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M3 5C3 4.44772 3.44772 4 4 4H16C16.5523 4 17 4.44772 17 5V15C17 15.5523 16.5523 16 16 16H4C3.44772 16 3 15.5523 3 15V5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M3 5L10 10L17 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                            Inquire
                        </button>
                      </Link>
                    </div>}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {filteredDatasets.length === 0 && (
          <div className="no-results">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <path d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M18 18L30 30M30 18L18 30" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <p>No datasets found matching your criteria</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Datasets;
